export function addSimpleUrlParameters(
  url: string,
  parameters?: Record<string, string>,
) {
  if (!parameters || !Object.keys(parameters || {}).length) {
    return url;
  }

  const utmParametersString = Object.entries(parameters)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  if (url.includes('?')) {
    return `${url}&${utmParametersString}`;
  } else {
    return `${url}?${utmParametersString}`;
  }
}

export function getUtmParamsFromUrl(url: string) {
  const urlObj = new URL(url);
  const utmParameters: Record<string, string> = {};
  urlObj.searchParams.forEach((value, key) => {
    if (key.startsWith('utm_')) {
      utmParameters[key] = value;
    }
  });

  return utmParameters;
}

export function addUtmParamsToAppStoreUrl(
  url: string,
  utmParameters: Record<string, string>,
) {
  return addSimpleUrlParameters(url, {
    ct: encodeURIComponent(
      `${utmParameters.utm_source}_${utmParameters.utm_medium}_${utmParameters.utm_campaign}`,
    ),
  });
}

export function addUtmParamsToPlayStoreUrl(
  url: string,
  utmParameters: Record<string, string>,
) {
  return addSimpleUrlParameters(url, {
    referrer: encodeURIComponent(
      `utm_source=${utmParameters.utm_source}&utm_medium=${utmParameters.utm_medium}&utm_campaign=${utmParameters.utm_campaign}`,
    ),
  });
}
